<template>
  <div>
    <center class="loading-medium" v-if="loading">
      <loading></loading>
    </center>
    <div class="content content-new" v-if="!loading">
      <div class="container-fluid">
        <div
          v-if="!(errorMessage == '' || errorMessage == null)"
          class="alert alert-danger text-center custom-width alert-custom"
        >
          <strong>{{ errorMessage }}</strong>
        </div>
        <div v-else>
          <div class="row" style="margin-bottom: 10px">
            <div class="col-xs-3">
              <h3>Users</h3>
            </div>
            <div class="col-xs-6"></div>
            <div class="col-xs-3">
              <img
                :src="BankLogo"
                style="
                  height: 90px;
                  width: 140px;
                  float: right;
                  margin-left: 20px;
                "
              />
            </div>
          </div>
          <div class="form-group form-inline custom-width">
            <input
              type="search"
              class="form-control search-box"
              style="background-color: white"
              placeholder="Search"
              v-model="Search"
            />
            <select
              class="form-control"
              v-model="UserStatus"
              style="margin-left: 4px"
            >
              <option value="0">All User</option>
              <option value="1">Active</option>
              <option value="2">Blocked</option>
              <option value="3">Deleted</option>
            </select>
            <button
              class="btn btn-primary"
              @click="ChangePageSizeORSearch"
              style="margin-left: 4px"
            >
              Search
            </button>
            <button
              class="btn btn-primary"
              @click="ExportCSV"
              style="margin-left: 4px"
            >
              Export to CSV
            </button>
            <button
              class="btn btn-primary"
              style="margin-left: 4px"
              @click="Print"
            >
              Print
            </button>
            <div class="pull-right">
              <button class="btn btn-primary" @click="Adduser">Add User</button>
            </div>
          </div>
          <div v-bind:id="'printable'">
            <strong v-currentdate></strong>
            <table class="table table-bordered ng-grid">
              <thead style="background: #efeeed">
                <tr>
                  <th>No.</th>

                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Name')"
                      >Name</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Name'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a
                      href="javascript:void(0)"
                      @click="ChangeOrder('Username')"
                      >Username</a
                    >

                    <span
                      class="sortorder"
                      v-show="currentSort == 'Username'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Email')"
                      >Email</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Email'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Role')"
                      >Role</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Role'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th>
                    <a href="javascript:void(0)" @click="ChangeOrder('Status')"
                      >Status</a
                    >
                    <span
                      class="sortorder"
                      v-show="currentSort == 'Status'"
                      :class="{ reverse: curentSortOrder == 'desc' }"
                    ></span>
                  </th>
                  <th class="Print">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(option, index) in OrderBy"
                  :key="index"
                  :class="{ even: index + (1 % 2) == 0 }"
                >
                  <td>
                    {{
                      (SelectedPageSize == "ALL" ? 0 : SelectedPageSize) *
                        (currentPage - 1) +
                      (index + 1)
                    }}
                  </td>
                  <td>{{ option.Name }}</td>
                  <td>{{ option.Username }}</td>
                  <td>{{ option.Email }}</td>
                  <td>{{ option.Role }}</td>
                  <td>{{ option.Status }}</td>
                  <td class="img Print">
                    <a
                      href="javascript:void(0)"
                      title="Edit User"
                      @click="EditUser(option.Id)"
                    >
                      <img src="../../assets/imgs/png/Action.png" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="custom-width">
            <div class="pull-left">
              <paginate
                ref="paginate"
                :page-count="PageCalculation"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :click-handler="clickCallback"
                :container-class="'pagination'"
              ></paginate>
            </div>
            <div class="btn-group form-inline pull-right pager">
              <label>Page Size :</label>
              <select
                v-model="SelectedPageSize"
                class="form-control input-sm"
                @change="ChangePageSizeORSearch"
              >
                <option v-for="(option, index) in PageSize" :key="index">
                  {{ option.key }}
                </option>
              </select>
            </div>
          </div>
          <pre class="custom-width">
Page:{{ currentPage }} / {{ PageCalculation }} </pre
          >
        </div>
      </div>
    </div>
    <User v-if="showModal" @Close="CloseModal" :UserId="UserId"></User>
  </div>
</template>



<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import User from "./User";
export default {
  data() {
    return {
      SelectedPageSize: 10,
      currentPage: 1,
      showModal: false,
      UserId: null,
      Search: null,
      currentSort: "Name",
      curentSortOrder: "asc",
      UserStatus: 1,
    };
  },
  components: {
    User,
  },
  methods: {
    ChangeOrder(key) {
      if (key == this.currentSort) {
        this.curentSortOrder = this.curentSortOrder == "asc" ? "desc" : "asc";
      } else {
        this.curentSortOrder = "asc";
      }
      this.currentSort = key;
      this.ChnageUrl();
    },
    clickCallback: function (page) {
      if (page) {
        this.currentPage = page;
        this.ChnageUrl();
        this.GetData();
      }
    },

    ChnageUrl() {
      var Url =
        "?page=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&dir=" +
        this.curentSortOrder +
        "&sort=" +
        this.currentSort +
        "&status=" +
        this.UserStatus;
      this.$router.push({ path: "" + Url });
    },
    ChangePageSizeORSearch() {
      this.currentPage = 1;
      this.ChnageUrl();
      this.GetData();
    },

    Print() {
      this.printData("printable", "Users");
    },
    Adduser() {
      this.showModal = true;
    },
    GetData() {
      var Url =
        "?currentpage=" +
        this.currentPage +
        "&pagesize=" +
        (this.SelectedPageSize == "ALL" ? "0" : this.SelectedPageSize) +
        "&search=" +
        (this.Search == null ? "" : this.Search) +
        "&status=" +
        this.UserStatus;
      var vm = this;
      this.$store
        .dispatch(ACTIONS.USER_GETALL, Url)
        .then((res) => {
          this.$refs.paginate.selected = vm.currentPage - 1;
        })
        .catch((err) => {});
    },
    // setBackUrl(key) {
    //   this.$router.push({ path: "VendorCommodities/" + key });
    // },
    EditUser(id) {
      this.UserId = id;
      this.showModal = true;
    },

    CloseModal() {
      this.showModal = false;
      this.UserId = null;
      this.GetData();
    },
    ExportCSV() {
      this.ObjectToCSV("User.csv", this.USERS, [
        "Name",
        "Username",
        "Email",
        "Role",
      ]);
    },
  },
  beforeMount() {
    if (this.$route.query) {
      if (this.$route.query.hasOwnProperty("pagesize")) {
        this.SelectedPageSize = this.$route.query["pagesize"];
      }
      if (this.$route.query.hasOwnProperty("search")) {
        this.Search = this.$route.query["search"];
      }
      if (this.$route.query.hasOwnProperty("page")) {
        this.currentPage = this.$route.query["page"];
      }

      if (this.$route.query.hasOwnProperty("sort")) {
        this.currentSort = this.$route.query["sort"];
      }
      if (this.$route.query.hasOwnProperty("dir")) {
        this.curentSortOrder = this.$route.query["dir"];
      }
      if (this.$route.query.hasOwnProperty("status")) {
        this.UserStatus = this.$route.query["status"];
      }
    }

    this.GetData();
  },

  computed: {
    ...mapGetters({
      PageSize: "PageSize",
      USERS: "GETUSERS",
      TotalRecords: "GETUSERTOTALPAGES",
      errorMessage: "GETUSERERRORMESSAGE",
      loading: "GETUSERLOADING",
      BankLogo: "GETBANKLOGO",
    }),
    OrderBy() {
      var data = [...this.USERS];
      var SortedArray = this.Sort(data, this.currentSort, this.curentSortOrder);
      if (!this.SelectedPageSize || this.SelectedPageSize == "ALL") {
        this.SelectedPageSize = SortedArray.length;
      }
      if (!this.currentPage) {
        this.currentPage = 1;
      }
      var sp = parseInt(this.SelectedPageSize); // selected Page
      var cp = parseInt(this.currentPage); // current page
      // var _pageData = this.Pagination(SortedArray, sp, cp);
      return this.Pagination(SortedArray, sp, cp);
      //return SortedArray;
    },
    PageCalculation() {
      var count = Math.ceil(this.TotalRecords / this.SelectedPageSize);
      return count > 0 ? count : 1;
    },
  },
};
</script>